import React from "react";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRouter } from "next/router";
import { BadgeAlert, BadgeCheck, ExternalLinkIcon } from "lucide-react";
import Image from "next/image";
import Loader from "@/components/Loader";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { useTranslation } from "react-i18next";
import SortAuthor from "./SortAuthor";

export default function AuthorLeaderboard({
  filtersAuthors,
  setFiltersAuthors,
  data,
  loadingAuthors,
}: any) {
  const { t } = useTranslation("marketplace-page");
  const getNameInitials = (name: any) => {
    const initials = name
      .split(" ")
      .slice(0, 2)
      .map((word: any) => word.charAt(0))
      .join("");
    return initials.toUpperCase();
  };
  const router = useRouter();

  return (
    <Card className="h-full w-full overflow-hidden">
      {/* Card Header */}
      <CardHeader className="p-0 relative z-10 ">
        <div className="absolute top-0 left-0 w-full bg-[hsl(var(--card))]   flex justify-between items-center z-10 p-2 pl-4 pr-3 ">
          <CardTitle className="flex items-center tracking-tight text-xs font-semibold">
            {filtersAuthors.sort_order == "win_p_desc" &&
              t("Highest Win Percentage")}
            {filtersAuthors.sort_order == "copiers_desc" &&
              t("Highest Copiers Count")}
            {filtersAuthors.sort_order == "total_strategies_desc" &&
              t("Highest Strategies Created")}
            {filtersAuthors.sort_order == "total_trades_desc" &&
              t("Highest Trades Triggered")}
          </CardTitle>
          <div>
            {filtersAuthors && (
              <SortAuthor
                filtersAuthors={filtersAuthors}
                setFiltersAuthors={setFiltersAuthors}
              />
            )}
          </div>
        </div>
      </CardHeader>

      {/* Card Content */}
      <CardContent className="h-full  overflow-auto p-0 pt-[15px]">
        {loadingAuthors ? (
          <div className="w-full flex items-center justify-center h-full">
            <Loader />
          </div>
        ) : (
          <div className="h-full w-full max-h-[100%] pt-[35px]">
            <Table className="w-full text-sm whitespace-nowrap">
              {/* Table Body */}
              <TableBody>
                {data.map((each: any, i: number) => {
                  let firstName = each?.user?.first_name?.split(" ")[0];
                  let lastName = each?.user?.last_name?.split(" ")[0];
                  let fullName = firstName + " " + lastName;

                  let badgeValue = JSON.parse(
                    each?.meta_data?.user_meta?.badge
                  )?.last_badge;

                  return (
                    <TableRow key={each.user.email} className="border-none p-0">
                      <TableCell
                        className="flex items-center p-3 border-none cursor-pointer"
                        onClick={() =>
                          router.push(
                            `/profile/${each.user.unique_key}?locale=${
                              router.query.locale || "en"
                            }`
                          )
                        }
                      >
                        <div
                          className={cn(
                            "flex  items-center justify-center rounded-full bg-muted w-[28px] h-[28px] mr-2 text-xs "
                          )}
                        >
                          {getNameInitials(fullName)}
                        </div>
                        {fullName}
                        {badgeValue == "rock" ? (
                          <BadgeAlert className="text-[#9B0505] w-[16px] h-[16px] ml-2" />
                        ) : badgeValue == "bronze" ? (
                          <BadgeCheck className="text-[#cd7f32] w-[16px] h-[16px] ml-2" />
                        ) : badgeValue == "silver" ? (
                          <BadgeCheck className="text-[#19438A] w-[16px] h-[16px] ml-2" />
                        ) : badgeValue == "gold" ? (
                          <BadgeCheck className="text-[#FFD700] w-[16px] h-[16px] ml-2" />
                        ) : (
                          ""
                        )}
                        <ExternalLinkIcon className="text-muted-foreground ml-2 w-[16px] h-[16px]" />
                      </TableCell>
                      {filtersAuthors.sort_order == "total_trades_desc" && (
                        <TableCell className="p-3">
                          {each?.meta_data?.total_trades}
                        </TableCell>
                      )}
                      {filtersAuthors.sort_order == "total_strategies_desc" && (
                        <TableCell className="p-3">
                          {each?.meta_data?.total_strategies}
                        </TableCell>
                      )}
                      {filtersAuthors.sort_order == "win_p_desc" && (
                        <TableCell className="p-3">
                          {each?.meta_data?.win_p >= 75 ? (
                            <div className="text-[--marketplace-green] flex items-center">
                              <Image
                                width={11}
                                height={11}
                                src="/images/marketplace/fire.png"
                                alt="fire image"
                                className="-ml-[15px] mr-1 "
                              />
                              {each?.meta_data?.win_p?.toFixed(1)}%
                            </div>
                          ) : each?.meta_data?.win_p >= 50 ? (
                            <div className="text-[--accent-secondary]">
                              {each?.meta_data?.win_p?.toFixed(1)}%
                            </div>
                          ) : each?.meta_data?.win_p >= 0 ? (
                            <div className="text-[--marketplace-red]">
                              {each?.meta_data?.win_p?.toFixed(1)}%
                            </div>
                          ) : (
                            "NA"
                          )}
                        </TableCell>
                      )}
                      {filtersAuthors.sort_order == "copiers_desc" && (
                        <TableCell className="p-3">
                          {each?.meta_data?.copiers_count}
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
